import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { useAIChat } from "@/Chat/ChatSidebar/AIChatContext";
import { NewChatExamples } from "@/Chat/ChatSidebar/NewChatView/NewChatExamples.tsx";
import { RobotoTypography } from "@/shared/components";

import styles from "./NewChatView.module.css";

const NewChatLogo = () => {
  return (
    <div className={styles.logoContainer}>
      <div className={styles.logoCircle}>
        <AutoAwesomeIcon className={styles.logoIcon} />
      </div>
      <div className={styles.logoTextContainer}>
        <RobotoTypography className={styles.logoTitle}>Roboto</RobotoTypography>
        <RobotoTypography className={styles.logoSubtitle}>
          (M.D., Ph.D., A.I.)
        </RobotoTypography>
      </div>
    </div>
  );
};

interface NewChatViewProps {
  onExampleClick: (question: string) => Promise<void>;
}

const NewChatView = ({ onExampleClick }: NewChatViewProps) => {
  const { context } = useAIChat();

  const handleExampleClick = (question: string) => {
    void onExampleClick(question);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentContainer}>
        <NewChatLogo />
        <RobotoTypography className={styles.helpText}>
          How can I help you?
        </RobotoTypography>
      </div>

      <NewChatExamples context={context} onExampleClick={handleExampleClick} />
    </div>
  );
};

export { NewChatView };
